import { Box, Typography, Grid, Paper, Alert } from '@mui/material'
import TimelineIcon from '@mui/icons-material/Timeline'
import FilterPanel from '../../components/FilterPanel'
import LongevityPerformance from '../../components/charts/LongevityPerformance'
import ASHRAEBenchmarkChart from '../../components/charts/ASHRAEBenchmarkChart'
import DegradationComparison from '../../components/charts/DegradationComparison'
import { useFilters } from '../../context/FilterContext'
import { DataQualityBanner } from '../../components/ui/DataQualityContext'

function LongevityAnalysis() {
  const { filteredData, activeFilterCount } = useFilters()

  return (
    <Box>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
        <TimelineIcon sx={{ fontSize: 32, color: 'primary.main' }} />
        <Box>
          <Typography variant="h4" sx={{ fontWeight: 700 }}>
            Longevity & ASHRAE Benchmarks
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Multi-year longevity studies and ASHRAE degradation model comparisons
          </Typography>
        </Box>
      </Box>

      <Box sx={{ mb: 3 }}>
        <FilterPanel compact />
      </Box>
      <Box sx={{ mb: 3 }}>
        <DataQualityBanner compact />
      </Box>

      {activeFilterCount > 0 && (
        <Alert severity="info" sx={{ mb: 3 }}>
          Showing analysis for {filteredData.length} filtered studies.
        </Alert>
      )}

      <Grid container spacing={3}>
        {/* Longevity Performance Chart */}
        <Grid item xs={12}>
          <Paper sx={{ p: { xs: 1.5, sm: 2 }, overflow: 'auto' }}>
            <LongevityPerformance />
          </Paper>
        </Grid>

        {/* ASHRAE Benchmark Chart */}
        <Grid item xs={12}>
          <Paper sx={{ p: { xs: 1.5, sm: 2 }, overflow: 'auto' }}>
            <ASHRAEBenchmarkChart />
          </Paper>
        </Grid>

        {/* Degradation Model Comparison */}
        <Grid item xs={12}>
          <Paper sx={{ p: { xs: 1.5, sm: 2 }, overflow: 'auto' }}>
            <DegradationComparison title="ASHRAE vs Corpus Degradation Models" />
          </Paper>
        </Grid>
      </Grid>

      {/* Methodology Note */}
      <Alert severity="success" icon={false} sx={{ mt: 4 }}>
        <Typography variant="subtitle2" gutterBottom>
          ASHRAE Methodology
        </Typography>
        <Typography variant="body2">
          ASHRAE degradation model assumes 2% COP decline per year (UCF/FSEC study) with 30% maximum.
          Corpus model is derived from PE-certified before/after measurements where equipment age was documented.
          The efficiency improvement from PermaFrost NMR treatment directly measures existing thermal degradation.
        </Typography>
      </Alert>
    </Box>
  )
}

export default LongevityAnalysis
